import { render } from "./ui-image-preview.vue?vue&type=template&id=12ba5d9e&ts=true"
import script from "./ui-image-preview.vue?vue&type=script&lang=ts"
export * from "./ui-image-preview.vue?vue&type=script&lang=ts"

import "./ui-image-preview.vue?vue&type=style&index=0&id=12ba5d9e&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__